module.exports = __webpack_public_path__ + "static/img/12.0076774.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/sp/12.png
// module id = ONBk
// module chunks = 0